import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import deleteIcon from '../../assets/img/delete_icon.svg';
import CancelIcon from '../../assets/img/CancelDesIcon.svg';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import { useParams } from 'react-router';
import { useAoneStore } from '../../store/AoneStore';
import { useIamStore } from "../../store/IAM/IamStore";
import { useSortingPanelStore } from "../../store/SortingMachine/SortingPanelStore";
import { useThirdPartyStore } from "../../store/ThirdParty/ThirdPartyStore";
import { useConfigStore } from "../../store/ConfigMgt/ConfigStore";
import { useCrmStore } from "../../store/CrmMgt/CrmStore";
import { useHubStore } from "../../store/HubMgt/HubStore";
import { useEmployeeMgtStore } from "../../store/EmployeeMgt/EmployeeMgtStore";
import { useMastersStore } from "../../store/MastersMgt/MastersStore";
import { useReasonStore } from "../../store/ReasonsMgt/ReasonStore";
import { usepickupStore } from '../../store/PickupRequest/pickuprequestStore';
import { useroutesStore } from '../../store/RoutesMgt/RoutesStore';
import { usevehicleStore } from '../../store/VehicleMgt/VehicleStore';
import { useLinehaulStore } from '../../store/ReasonsMgt/LinehaulStore';
import { useNotificationStore } from '../../store/NotificationsMgt/NotificationStore';
import { useAclStore } from '../../store/AclMgt/Aclstore';
import { useDriverStore } from '../../store/DriverMgt/driverStore';
import { useTripStore } from '../../store/TripMgt/TripStore';
import { useRatesStore } from '../../store/Rates/RateStore';
import { useIccStore } from '../../store/IccMgt/IccStore';
import { useDlFlowStore } from '../../store/DeliveryFlowMgt/DeliveryFlowStore';
import { useShortAddressStore } from '../../store/ShortAddress/ShortAddressStore';
import { usePlLockerStore } from '../../store/ParcelLockers/PlLockerStore';
import { useRtoStore } from '../../store/RtoMgt/RtoStore';
import { useEmployeeStore } from '../../store/Employees/EmployeeStore';
import { useComplaintStore } from '../../store/Complaints/ComplaintStore';
import { usecourierStore } from '../../store/CourierMgt/courierStore';
import { showSuccessToast, showErrorToast } from '../Toast/Toaster';
import { useDeliveryStore } from '../../store/DeliveryMgt/DeliveryStore';
import { usesettingStore } from '../../store/Settings/SettingStore';
import { useRevenueStore } from '../../store/RevenueMgt/RevenueStore';
import { useOrderStore } from '../../store/OrderMgt/OrderStore';
import { useCodAutomationStore } from "../../store/CodAutomation/codAutomationStore";
import { useSortingStore } from '../../store/SortingMachine/SortingMachinStore';
const DeletingModal = ({
  deleteHandler,
  setDeleteHandler,
  deleteParams,
  setDeleteParams,
  deleteParamsId,
  setDeleteParamsId,
  selectAll,
  setSelectAll,
  setShowActions,
  showActions,
  setselectZone,
  isChangedPl,
  SetIsChangedPl,
  setSelectedTrackingId,
  setIsListChange,
}) => {
  const params = useParams();
  const deleteRoleById = useIamStore((state) => state?.deleteRoleById);
  const deleteGroupById = useIamStore((state) => state?.deleteGroupById);
  const deleteUserById = useIamStore((state) => state?.deleteUserById);
  const deleteModuleById = useIamStore((state) => state?.deleteModuleById);
  const deleteSubModuleById = useIamStore((state) => state?.deleteSubModuleById);
  const deleteModelById = useIamStore((state) => state?.deleteModelById);
  const deletePermissionById = useIamStore((state) => state?.deletePermissionById);
  const iamAccessSetupDeletes = {
    'IAM Module': deleteModuleById,
    'IAM Sub Module': deleteSubModuleById,
    'IAM Model': deleteModelById,
    'IAM Permission': deletePermissionById,
  };
  const deleteChuteConfigs = useSortingPanelStore((state) => state?.deleteChuteConfigs);
  const deleteThirdparty = useThirdPartyStore((state) => state?.deleteThirdparty);
  const deleteCountryById = useConfigStore((state) => state?.deleteCountryById);
  const deleteRegionById = useConfigStore((state) => state?.deleteRegionById);
  const deleteCityById = useConfigStore((state) => state?.deleteCityById);
  const deleteDistrictById = useConfigStore((state) => state?.deleteDistrictById);
  const deleteMapping = useThirdPartyStore((state) => state?.deleteMapping);
  const deleteTeamLeaders = usecourierStore(
    (state) => state?.deleteTeamLeaders
  );
  const deleteDrivers = useDriverStore((state) => state?.deleteDrivers);
  const deleteTrips = useTripStore((state) => state?.deleteTrips);
  const deleteVat = useRatesStore((state) => state?.deleteVat);
  const deletePlatform = useRatesStore((state) => state?.deletePlatform);
  const deleteRebate = useRatesStore((state) => state?.deleteRebate);
  const deleteLocalization = usesettingStore(
    (state) => state?.deleteLocalization
  );
  const deleteComplaints = useComplaintStore(
    (state) => state?.deleteComplaints
  );
  const deleteStation = useIccStore((state) => state?.deleteStation);
  const deleteLastMileRoutes = useIccStore((state) => state?.deleteRoutes);
  const deleteLocation = useIccStore((state) => state?.deleteLocation);
  const deleteResources = usesettingStore((state) => state?.deleteResources);
  const deletePayroll = useEmployeeStore((state) => state?.deletePayroll);
  const deleteProvider = usePlLockerStore((state) => state?.deleteProvider);
  const deleteUser = usePlLockerStore((state) => state?.deleteUser);
  const deleteDimensions = usePlLockerStore((state) => state?.deleteDimensions);
  const deleteCities = usePlLockerStore((state) => state?.deleteCities);
  const deleteRequest = usePlLockerStore((state) => state?.deleteRequest);
  const deleteRefund = useRevenueStore((state) => state?.deleteRefund);
  const deleteBadAddress = useOrderStore((state) => state?.deleteBadAddress);
  const deleteTemplates = useNotificationStore(
    (state) => state?.deleteTemplates
  );
  const deleteRules = useNotificationStore((state) => state?.deleteRules);
  const deleteGpa = useRatesStore((state) => state?.deleteGpa);
  const cancelRto = useRtoStore((state) => state?.cancelRto);
  const removeAclConsignments = useAclStore(
    (state) => state?.removeAclConsignments
  );
  const deleteDeliveryflowbyId = useDlFlowStore(
    (state) => state?.deleteDeliveryflowbyId
  );
  const deleteCountryMappingById = useConfigStore(
    (state) => state?.deleteCountryMappingById
  );
  const deleteRegionMappingById = useConfigStore(
    (state) => state?.deleteRegionMappingById
  );
  const deleteCityMappingById = useConfigStore(
    (state) => state?.deleteCityMappingById
  );
  const deleteDistrictMappingById = useConfigStore(
    (state) => state?.deleteDistrictMappingById
  );
  const deleteCurrencyById = useConfigStore((state) => state?.deleteCurrencyById);
  const deleteCurrencyConversionById = useConfigStore(
    (state) => state?.deleteCurrencyConversionById
  );
  const deleteZoneById = useConfigStore((state) => state.deleteZoneById);
  const deleteCustomer = useCrmStore((state) => state.deleteCustomer);
  const deleteHubs = useHubStore((state) => state.deleteHubs);
  const deleteShortAddressHistory = useShortAddressStore((state) => state.deleteShortAddressHistory);
  const deleteBlackListCodeAction = useShortAddressStore(
    state => state.deleteBlackListCodeAction
  );
  const deleteServiceareas = useHubStore((state) => state.deleteServiceareas);
  const deleteAreas = useEmployeeMgtStore((state) => state.deleteAreas);
  const deleteProducts = useMastersStore((state) => state.deleteProducts);
  const deleteOrigin = useMastersStore((state) => state.deleteOrigin);
  const deleteRoutes = useroutesStore((state) => state.deleteRoutes);
  const deleteDestination = useMastersStore((state) => state.deleteDestination);
  const deleteTransittime = useMastersStore((state) => state.deleteTransittime);
  const deleteFreight = useMastersStore((state) => state.deleteFreight);
  const deleteRto = useMastersStore((state) => state.deleteRto);
  const deleteCod = useMastersStore((state) => state.deleteCod);
  const deleteOda = useMastersStore((state) => state.deleteOda);
  const deleteFuel = useMastersStore((state) => state.deleteFuel);
  const deleteDeliveryValidation = useDeliveryStore(
    (state) => state.deleteDeliveryValidation
  );
  const countTasks = useDeliveryStore((state) => state.countTasks);
  const deleteInsurance = useMastersStore((state) => state.deleteInsurance);
  const deleteAttempts = useMastersStore((state) => state.deleteAttempts);
  const deleteShortAddressbyId = useShortAddressStore(
    (state) => state.deleteShortAddressbyId
  );
  const deletePickupConsignment = usepickupStore(
    (state) => state?.deletePickupConsignment
  );
  const deleteHoldReasonsById = useReasonStore(
    (state) => state.deleteHoldReasonsById
  );
  const deleteAddressChangeReasonsById = useReasonStore(
    (state) => state.deleteAddressChangeReasonsById
  );
  const deleteZonegroupById = useConfigStore(
    (state) => state.deleteZonegroupById
  );
  const deletepickupaddressbyId = useCrmStore(
    (state) => state.deletepickupaddressbyId
  );
  const deletePickupReasonsById = useReasonStore(
    (state) => state.deletePickupReasonsById
  );
  const deleteDeliveryReasonsById = useReasonStore(
    (state) => state.deleteDeliveryReasonsById
  );
  const deleteLineHaulsbyId = useLinehaulStore(
    (state) => state.deleteLineHaulsbyId
  );
  const deletePlbyId = useLinehaulStore((state) => state.deletePlbyId);
  const deleteTiers = useConfigStore((state) => state.deleteTiers);
  const deleteOdTier = useConfigStore((state) => state.deleteOdTier);
  const deleteEmployees = useEmployeeMgtStore((state) => state.deleteEmployees);
  const deleteVehicles = usevehicleStore((state) => state.deleteVehicles);
  const deleteVehicleDocuments = usevehicleStore(
    (state) => state.deleteVehicleDocuments
  );
  const deleteVehicleCategory = usevehicleStore(
    (state) => state.deleteVehicleCategory
  );
  const deleteVehicleVendor = usevehicleStore(
    (state) => state.deleteVehicleVendor
  );
  const deleteOdoMeter = usevehicleStore((state) => state.deleteOdoMeter);
  const deleteGpsvendor = usevehicleStore((state) => state.deleteGpsvendor);
  const setispostAdded = useAoneStore((state) => state.setispostAdded);
  const ispostAdded = useAoneStore((state) => state?.ispostAdded);
  const deleteWaybillByBagId = useSortingPanelStore(
    (state) => state?.deleteWaybillByBagId
  );
  const deleteBagById = useSortingPanelStore((state) => state?.deleteBagById);
  const deleteChuteConfigsByIdV2 = useSortingStore((state) => state?.deleteChuteConfigsByIdV2);
  const deleteChuteConfigsById = useSortingPanelStore(
    (state) => state?.deleteChuteConfigsById
  );
  const deleteChuteConfigsBulkById = useSortingPanelStore(
    (state) => state?.deleteChuteConfigsBulkById
  );
  const deleteBankCharges = useCodAutomationStore((state) => state?.deleteBankCharges);
  const getAllBankCharges = useCodAutomationStore((state) => state?.getAllBankCharges);
  const [countryParam, setCountryParam] = useState('SAU');
  const countCourierTasks = async (courierId) => {
    const res = await countTasks(courierId);
    sessionStorage.setItem('assignedCount', res?.data?.data?.assigned);
    sessionStorage.setItem('scannedCount', res?.data?.data?.scanned);
  };
  const setSaveHandlerAction = useAoneStore((state) => state?.setSaveHandler);
  const saveHandler = useAoneStore((state) => state?.saveHandler);
  const deleteAgentConfigs = useSortingPanelStore((state) => state?.deleteAgentConfigs);
  const handleClose = () => {
    setDeleteHandler(false);
    setDeleteParams({ id: '', name: '', title: '' });
    setSaveHandlerAction(!saveHandler);
    confirmation.resetForm();
  };
  const confirmation = useFormik({
    initialValues: {
      value: '',
      confirm: `Delete ${deleteParams?.name}`,
    },
    enableReinitialize: true,
    validationSchema: object({
      value: string().test(
        'confirm-text',
        'Please enter the text exactly as displayed to confirm',
        (value) => {
          if (deleteParams?.title === 'Chutes') {
            return true;
          } else if (deleteParams?.title === 'Team Leader') {
            return true;
              } else if (deleteParams?.title === 'Refund') {
            return true;
          } else if (deleteParams?.title === 'Bad Address') {
            return true;
          } else {
            return value === confirmation.values.confirm;
          }
        }
      ),
    }),
    onSubmit: async () => {
      if (deleteParams?.title == 'Agent') {
        await deleteAgentConfigs(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast('Agent Deleted');
          }
        });
      } else if (deleteParams?.title == 'Chute') {
        const zoneParams = `zoneCodes=${deleteParams?.id}`;
        await deleteChuteConfigsByIdV2(deleteParams?.id, zoneParams).then(
          (response) => {
            handleClose();
            if (response.status == '200') {
              showSuccessToast('Chute Deleted');
            }
          }
        );
      } else if (deleteParams?.title == 'Chutes') {
        const zoneParams = `zoneCodes=${deleteParams?.id}`;
        await deleteChuteConfigsById(params?.id, zoneParams).then(
          (response) => {
            handleClose();
            if (response.status === 200) {
              showSuccessToast('Chutes Deleted');
            }
          }
        );
      } else if (deleteParams?.title == 'Config') {
        await deleteChuteConfigs(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast('Config Deleted');
          }
        });
      } else if (deleteParams?.title == 'Country') {
        await deleteCountryById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'Providers') {
        await deleteProvider(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'Complaints') {
        await deleteComplaints(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'Provider User') {
        await deleteUser(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'Allowed Dimensions') {
        await deleteDimensions(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            SetIsChangedPl(!isChangedPl);
          }
        });
      } else if (deleteParams?.title == 'Allowed City') {
        await deleteCities(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            SetIsChangedPl(!isChangedPl);
          }
        });
      } else if (deleteParams?.title == 'Provider Request') {
        await deleteRequest(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'Refund') {
        await deleteRefund(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
           }else if (response?.data?.status == 'SUCCESS') {
                 showSuccessToast(`${deleteParams.name} has been Cancelled`);
          } else {
            showSuccessToast(`${deleteParams.name} has been Cancelled`);
          }
        });
      } else if (deleteParams?.title == 'Region') {
        await deleteRegionById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'City') {
        await deleteCityById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'Localization') {
        await deleteLocalization(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title == 'Payroll Company') {
        await deletePayroll(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title == 'ACL Consignments') {
        await removeAclConsignments(deleteParams?.id, deleteParams?.name).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else if (response?.response?.data?.status == 'ERROR') {
              const errorMessage = response?.response?.data?.msg;
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
              setispostAdded(!ispostAdded);
            }
          }
        );
      } else if (deleteParams?.title == 'SMS Templates') {
        await deleteTemplates(deleteParams?.id, deleteParams?.name).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else if (response?.response?.data?.status == 'ERROR') {
              const errorMessage = response?.response?.data?.msg;
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
              setispostAdded(!ispostAdded);
            }
          }
        );
      } else if (deleteParams?.title == 'SMS Rules') {
        await deleteRules(deleteParams?.id, deleteParams?.name).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else if (response?.response?.data?.status == 'ERROR') {
              const errorMessage = response?.response?.data?.msg;
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
              setispostAdded(!ispostAdded);
            }
          }
        );
      } else if (deleteParams?.title == 'Resources') {
        await deleteResources(deleteParams?.id, deleteParams?.name).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else if (response?.response?.data?.status == 'ERROR') {
              const errorMessage = response?.response?.data?.msg;
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
              setispostAdded(!ispostAdded);
            }
          }
        );
      } else if (deleteParams?.title == 'District') {
        await deleteDistrictById(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast('District Deleted');
          }
        });
      } else if (deleteParams?.title === 'Thirdparty') {
        await deleteThirdparty(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast('Thirdparty Deleted');
          }
        });
      } else if (deleteParams?.title === 'Mapping') {
        await deleteMapping(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast('Mapping Deleted');
          }
        });
      } else if (deleteParams?.title === 'Bags') {
        await deleteBagById(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Customers') {
        await deleteCustomer(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'CountriesMap') {
        await deleteCountryMappingById(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'RegionsMap') {
        await deleteRegionMappingById(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'CitiesMap') {
        await deleteCityMappingById(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'PickupAddress') {
        await deletepickupaddressbyId(params?.id, deleteParams?.id).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
            }
          }
        );
      } else if (deleteParams?.title === 'RTO') {
        await cancelRto(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Bad Address') {
        await deleteBadAddress(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setSelectedTrackingId("");
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Currency') {
        await deleteCurrencyById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Tiers') {
        await deleteTiers(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'OD-Tiers') {
        await deleteOdTier(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Vehicles') {
        await deleteVehicles(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams?.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Vehicle Category') {
        await deleteVehicleCategory(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams?.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Vendors') {
        await deleteVehicleVendor(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams?.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Team Leader') {
        await deleteTeamLeaders(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams?.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'ShortAddress') {
        await deleteShortAddressbyId(countryParam, deleteParams?.id).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams?.name} has been Deleted`);
            }
          }
        );
      } else if (deleteParams?.title === 'Odometer') {
        await deleteOdoMeter(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams?.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Gps vendors') {
        await deleteGpsvendor(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams?.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Vehicle Documents') {
        await deleteVehicleDocuments(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams?.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Currencyconversions') {
        await deleteCurrencyConversionById(deleteParams?.id).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
            }
          }
        );
      } else if (deleteParams?.title === 'Products') {
        await deleteProducts(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Origins') {
        let paramslink = `?ProductCode=${params?.id}`;
        await deleteOrigin(params?.id, deleteParams?.id, paramslink).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
            }
          }
        );
      } else if (deleteParams?.title === 'Transit Time') {
        let paramslink = `?ProductCode=${params?.id}`;
        await deleteTransittime(params?.id, deleteParams?.id, paramslink).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
            }
          }
        );
      } else if (deleteParams?.title === 'Freight Rate') {
        await deleteFreight(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'RTO Rate') {
        await deleteRto(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'ODA Rate') {
        await deleteOda(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Delivery Validation') {
        await deleteDeliveryValidation(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            if (sessionStorage.getItem('SelectedCourier') !== null) {
              countCourierTasks(sessionStorage.getItem('SelectedCourier'));
              setispostAdded(!ispostAdded);
            }
          }
        });
      } else if (deleteParams?.title === 'Routes') {
        await deleteRoutes(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Routes ') {
        await deleteLastMileRoutes(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Station') {
        await deleteStation(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Locations') {
        await deleteLocation(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.status == 'ERROR') {
            const errorMessage = response?.response?.data?.msg;
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'COD Rate') {
        await deleteCod(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Fuel Rate') {
        await deleteFuel(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Insurance Rate') {
        await deleteInsurance(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Attempts Rate') {
        await deleteAttempts(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Platform Rate') {
        await deletePlatform(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
          } else if (deleteParams?.title === 'Rebate Rate') {
        await deleteRebate(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Vat Rate') {
        await deleteVat(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Gpa Rate') {
        await deleteGpa(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Consignments') {
        await deletePickupConsignment(params?.id, deleteParams?.id).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
              setispostAdded(!ispostAdded);
            }
          }
        );
      } else if (deleteParams?.title === 'Destinations') {
        let paramslink = `?ProductCode=${params?.id}`;
        await deleteDestination(params?.id, deleteParams?.id, paramslink).then(
          (response) => {
            handleClose();
            if (response?.data?.status == 'ERROR') {
              const errorMessage = response?.data?.msg.split(',')[0];
              showErrorToast(errorMessage);
            } else {
              showSuccessToast(`${deleteParams.name} has been Deleted`);
            }
          }
        );
      } else if (deleteParams?.title === 'Hubs') {
        await deleteHubs(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === "Short Address") {
        await deleteBlackListCodeAction(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == "ERROR") {
            const errorMessage = response?.data?.msg.split(",")[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
         } else if (deleteParams?.title === "Short Address History") {
        await deleteShortAddressHistory("SAU", deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == "ERROR") {
            const errorMessage = response?.data?.msg.split(",")[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Employees') {
        await deleteEmployees(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Outsource') {
        await deleteEmployees(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Areas') {
        await deleteAreas(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Service Areas') {
        await deleteServiceareas(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'NPR') {
        await deletePickupReasonsById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'NDR') {
        await deleteDeliveryReasonsById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Drivers') {
        await deleteDrivers(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Trip') {
        await deleteTrips(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Delivery Flow') {
        await deleteDeliveryflowbyId(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            setispostAdded(!ispostAdded);
          }
        });
      } else if (deleteParams?.title === 'Linehauls') {
        await deleteLineHaulsbyId(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'PL Reason') {
        await deletePlbyId(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Hold Reasons') {
        await deleteHoldReasonsById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Address Change Reasons') {
        await deleteAddressChangeReasonsById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'DistrictsMap') {
        await deleteDistrictMappingById(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Zones') {
        await deleteZoneById(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            setispostAdded(!ispostAdded);
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Zonesgroup') {
        await deleteZonegroupById(deleteParams?.id).then((response) => {
          handleClose();
          if (response.status == '200') {
            setispostAdded(!ispostAdded);
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === 'Waybill') {
        await deleteWaybillByBagId(
          deleteParamsId?.idTwo,
          deleteParamsId?.idOne
        ).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response.data.msg;
            const firstCommaIndex = errorMessage.indexOf(',');
            const toastMessage =
              firstCommaIndex !== -1
                ? errorMessage.substring(0, firstCommaIndex)
                : errorMessage;
            showErrorToast(toastMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'User') {
        await deleteUserById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (iamAccessSetupDeletes[deleteParams?.title]) {
        await iamAccessSetupDeletes[deleteParams.title](deleteParams?.id).then((response) => {
          handleClose();
          const body = response?.data?.status == 'ERROR' ? response.data : response?.response?.data;
          if (body) {
            showErrorToast(body?.msg?.split(',')[0] || 'Something went wrong');
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'Role') {
        await deleteRoleById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title == 'Group') {
        await deleteGroupById(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      } else if (deleteParams?.title === "Bank Charges") {
        await deleteBankCharges(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else if (response?.response?.data?.msg) {
            showErrorToast(response?.response?.data?.msg);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
            getAllBankCharges();
          }
        });
      }
      handleClose();
    },
  });
  const confirmationRto = useFormik({
    initialValues: {
      value: '',
      confirm: `Cancel ${deleteParams?.name}`,
    },
    enableReinitialize: true,
    validationSchema: object({
      value: string().test(
        'confirm-text',
        'Please enter the text exactly as displayed to confirm',
        (value) => {
          if (deleteParams?.title === 'Chutes') {
            return true; // No validation for "Chutes"
          } else {
            return value === confirmationRto.values.confirm;
          }
        }
      ),
    }),
    onSubmit: async () => {
      if (deleteParams?.title === 'RTO') {
        await cancelRto(deleteParams?.id).then((response) => {
          handleClose();
          if (response?.data?.status == 'ERROR') {
            const errorMessage = response?.data?.msg.split(',')[0];
            showErrorToast(errorMessage);
          } else {
            showSuccessToast(`${deleteParams.name} has been Deleted`);
          }
        });
      }
      handleClose();
    },
  });
  return (
    <>
      <Modal
        className="deleteAccpopup"
        show={deleteHandler}
        onHide={handleClose}
        centered
      >
        <Modal.Body>
          <div className="popupheadinglogo">
            <img
  src={
    ['Bad Address', 'Refund'].includes(deleteParams?.title)
      ? CancelIcon
      : deleteIcon
  }
  alt={
    ['Bad Address', 'Refund'].includes(deleteParams?.title)
      ? 'cancel'
      : 'delete'
  }
/>
          </div>
          <h2 className="fontSize20 fontWeight600 textAlignCenter blackText mb_8">
            {['RTO', 'Refund'].includes(deleteParams?.title) ? (
              <>Cancel {deleteParams?.title}?</>
            ) : deleteParams?.title === 'Bad Address' ? (
              <>Dismiss {deleteParams?.title}?</>
            ) : (
              <>Delete {deleteParams?.title}?</>
            )}
          </h2>
          {deleteParams?.title !== 'Chutes' && (
            <>
              {deleteParams?.title && (
                <>
                  <p className="fontSize14 fontWeight400 blackText textAlignCenter mb_16">
                    {deleteParams?.title !== 'Team Leader' &&
                    deleteParams?.title !== 'Refund' &&
                      deleteParams?.title !== 'Bad Address' &&
                      'The below resources will be affected:'}
                  </p>
                  <div className="displayFlex alignItemCenter justifyContent_center">
                    <ul className="emptyUnorderList mb_24">
                      {deleteParams?.title == 'Agent' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Agent resources
                        </li>
                      ) : deleteParams?.title == 'Chute' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Chute resources
                        </li>
                      ) : deleteParams?.title == 'Country' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Deleting the country will delete related regions,
                          cities and districts. Do you want to continue?
                        </li>
                      ) : deleteParams?.title == 'Region' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Region resources
                        </li>
                      ) : deleteParams?.title == 'City' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - City resources
                        </li>
                      ) : deleteParams?.title == 'District' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - District resources
                        </li>
                      ) : deleteParams?.title == 'CountriesMap' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Country Mapping resources
                        </li>
                      ) : deleteParams?.title == 'RegionsMap' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Region Mapping resources
                        </li>
                      ) : deleteParams?.title == 'CitiesMap' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - City Mapping resources
                        </li>
                      ) : deleteParams?.title == 'Currency' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Currency resources
                        </li>
                      ) : deleteParams?.title == 'Currencyconversions' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Currency conversion resources
                        </li>
                      ) : deleteParams?.title == 'Localization' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Localization resources
                        </li>
                      ) : deleteParams?.title == 'DistrictsMap' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - District Mapping resources
                        </li>
                      ) : deleteParams?.title == 'Config' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Config resources
                          </li>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Chute resources
                          </li>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Agent resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'User' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - User resources
                        </li>
                      ) : deleteParams?.title == 'Drivers' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Driver resources
                        </li>
                      ) : deleteParams?.title == 'Trip' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Trip resources
                        </li>
                      ) : deleteParams?.title == 'Tiers' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Tier resources
                        </li>
                      ) : deleteParams?.title == 'Customers' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Customer resources
                        </li>
                      ) : iamAccessSetupDeletes[deleteParams?.title] ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - {deleteParams.title} resources
                        </li>
                      ) : deleteParams?.title == 'Role' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Role resources
                          </li>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - User resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Hubs' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Hubs resources
                          </li>
                        </>
                      ) : deleteParams?.title == "Short Address" ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Blacklist resources
                          </li>
                        </>
                         ) : deleteParams?.title == "Short Address History" ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Short Address resources
                          </li>
                        </>
                      ) : deleteParams?.title == "Bank Charges" ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Bank Charges resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Vehicles' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Vehicle resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Odometer' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Odometer resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Gps vendors' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - GPS Vendors resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Vehicle Category' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Vehicle Category resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Vendors' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Vendor resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Vehicle Documents' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Vehicle Document resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Consignments' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Consignment resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Routes' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Routes resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Routes ' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Routes resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Refund ' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Refund resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Station' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Station resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Locations' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Location resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'OD-Tiers' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - OD Pair resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Service Areas' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Service area resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Delivery Flow' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Delivery flow resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'NPR' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Pickup Reasons resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'NDR' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Delivery Reasons resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Delivery Validation' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Delivery Validation resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Linehauls' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Linehaul Reasons resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'PL Reason' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - PL Reasons resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Hold Reasons' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Hold Reasons resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Address Change Reasons' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Address Change Reasons resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Team Leader' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Deleting the team leader will unassign the
                            existing couriers under him.
                          </li>
                        </>
                      ) : deleteParams?.title == 'PickupAddress' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Pickup Address resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'RTO' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Cancel RTO Request
                          </li>
                        </>
                      ) : deleteParams?.title == 'Freight Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Freight Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'COD Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - COD Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Providers' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Provider resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Bad Address' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - On removing, {deleteParams.id} will be removed from the
                            Bad Address list.
                          </li>
                        </>
                         ) : deleteParams?.title == 'Refund' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Do you want to cancel the refund for {deleteParams?.name}?
                          </li>
                        </>
                      ) : deleteParams?.title == 'Complaints' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Complaints resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Provider User' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - User resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Allowed Dimensions' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Dimension resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Allowed City' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - City resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Provider Request' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Provider Request resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'RTO Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - RTO Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'ODA Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - ODA Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Resources' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Fuel Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Fuel Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'ACL Consignments' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Consignments in ACL
                          </li>
                        </>
                      ) : deleteParams?.title == 'Payroll Company' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Payroll Company resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Insurance Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Insurance Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Attempts Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Attempts Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Platform Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Platform Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Vat Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Vat Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Gpa Rate' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - GPA Rate resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Products' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Products resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Destinations' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Destination resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Origins' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Origin resources
                          </li>
                        </>
                      ) : deleteParams?.title == 'Transit Time' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Transit Time resources
                          </li>
                        </>
                      ) : deleteParams?.title === 'Thirdparty' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Third Party
                          </li>
                        </>
                      ) : deleteParams?.title === 'Mapping' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Mapping Config
                          </li>
                        </>
                      ) : deleteParams?.title === 'Zones' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Zones resources
                          </li>
                        </>
                      ) : deleteParams?.title === 'SMS Templates' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - SMS Template resources
                          </li>
                        </>
                      ) : deleteParams?.title === 'SMS Rules' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - SMS Rules resources
                          </li>
                        </>
                      ) : deleteParams?.title === 'Zonesgroup' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Zone Group resources
                          </li>
                        </>
                      ) : deleteParams?.title === 'Bags' ? (
                        <li className="fontSize14 fontWeight400 blackText ">
                          - Bag
                        </li>
                      ) : deleteParams?.title === 'Waybill' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Waybill
                          </li>
                        </>
                      ) : deleteParams?.title === 'ShortAddress' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Short Address Mapping
                          </li>
                        </>
                          ) : deleteParams?.title === 'Short Address History' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Short Address History
                          </li>
                        </>
                      ) : deleteParams?.title === 'Employees' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Employee resources
                          </li>
                        </>
                      ) : deleteParams?.title === 'Outsource' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Outsource/Crowdsource resources
                          </li>
                        </>
                      ) : deleteParams?.title === 'Areas' ? (
                        <>
                          <li className="fontSize14 fontWeight400 blackText ">
                            - Area resources
                          </li>
                        </>
                      ) : (
                        deleteParams?.title == 'Group' && (
                          <>
                            <li className="fontSize14 fontWeight400 blackText ">
                              - Group resources
                            </li>
                            <li className="fontSize14 fontWeight400 blackText ">
                              - Role resources
                            </li>
                            <li className="fontSize14 fontWeight400 blackText ">
                              - User resources
                            </li>
                          </>
                        )
                      )}
                    </ul>
                  </div>
                </>
              )}
            </>
          )}

          {!['Chutes', 'RTO', 'Team Leader', 'Bad Address', 'Refund'].includes(
  deleteParams?.title
) && (
            <div>
              <p className="fontSize14 fontWeight400 blackText textAlignCenter mb_12">
                Type "{confirmation.values.confirm}" to confirm
              </p>
              <input
                type="text"
                className="deleteAcc_input"
                placeholder=""
                style={{
                  border: confirmation?.errors?.value && '2px solid red',
                }}
                name="value"
                onChange={(e) =>
                  confirmation.setFieldValue('value', e.target.value)
                }
                onBlur={confirmation.handleBlur}
                value={confirmation.values.value}
              />
              {confirmation.touched.value && confirmation.errors.value && (
                <p
                  className="requiredText"
                  style={{ textAlign: 'center', marginTop: '5px' }}
                >
                  {confirmation.errors.value}
                </p>
              )}
            </div>
          )}
          {deleteParams?.title == 'RTO' && (
            <div>
              <p className="fontSize14 fontWeight400 blackText textAlignCenter mb_12">
                Type "{confirmationRto.values.confirm}" to confirm
              </p>
              <input
                type="text"
                className="deleteAcc_input"
                placeholder=""
                style={{
                  border: confirmationRto?.errors?.value && '2px solid red',
                }}
                name="value"
                onChange={(e) =>
                  confirmationRto.setFieldValue('value', e.target.value)
                }
                onBlur={confirmationRto.handleBlur}
                value={confirmationRto.values.value}
              />
              {confirmationRto.touched.value &&
                confirmationRto.errors.value && (
                  <p
                    className="requiredText"
                    style={{ textAlign: 'center', marginTop: '5px' }}
                  >
                    {confirmationRto.errors.value}
                  </p>
                )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ flexWrap: 'unset' }}>
          <div>
            <button
              type="button"
              className="deletebtn cancelPrimary"
              onClick={() => {
                handleClose();
                if (setSelectAll !== undefined) {
                  setSelectAll(false);
                  setShowActions(false);
                  setselectZone([]);
                }
              }}
            >
              Cancel
            </button>
          </div>
          <div>
            {deleteParams?.title !== 'RTO' ? (
              <button
                type="button"
                className="deletebtn confirmPrimary"
                onClick={confirmation.handleSubmit}
              >
                Confirm
              </button>
            ) : (
              <button
                type="button"
                className="deletebtn confirmPrimary"
                onClick={confirmationRto.handleSubmit}
              >
                Confirm
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeletingModal;
